import {
    Button,
    Group,
    Text,
    ActionIcon
} from "@mantine/core";
import {Tag} from "../../tags/types.ts";
import {useNavigate} from "react-router-dom";
import {AiOutlineClose} from "react-icons/ai";

export const TagsGroup = ({
    value, 
    onRemove
}: { 
    value: Tag[] | null | undefined,
    onRemove?: (tagId: string) => void
}) => {
    const navigate = useNavigate()

    return (
        <Group gap={'xs'}>
            {value && value.map((tag, index) => (
                <Button 
                    key={index}
                    variant="filled" 
                    radius={'lg'} 
                    size={'compact-xs'}
                    onClick={() => navigate(`/tags/${tag.id}`)}
                    rightSection={onRemove ? (
                        <ActionIcon
                            size={14}
                            variant="transparent"
                            c="white"
                            onClick={(e) => {
                                e.stopPropagation();
                                onRemove(tag.id);
                            }}
                        >
                            <AiOutlineClose size={10} />
                        </ActionIcon>
                    ) : undefined}
                >
                    <Text size={'0.8em'}>{tag.name}</Text>
                </Button>
            ))}
        </Group>
    );
};


